import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const cMLoaApi = createApi({
  reducerPath: 'cMLoaApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Loa', 'Campaign'],
  endpoints: (builder) => ({
    getLoa: builder.query({
      query: (params) => ({
        url: `/campaigns/loa/`,
        params,
      }),
      providesTags: ['Loa'],
      
    }),

    updateLoa: builder.mutation({
      query: (data) => ({
        url: `/campaigns/loa/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Loa', 'Campaign'],
    }),

   
  }),
});

export const {
  useGetLoaQuery,
  useUpdateLoaMutation,
} = cMLoaApi;
